export * from './ValidatorMark';

export default (group)=> {

  let rules    = require.context('./groups/', true, /.js$/);
  let selected = rules.keys().filter((rule)=> rule.includes(group));

  return (type, input, opts={})=> {

    let error = null;

    for(let file of selected) {
      if( file.split("/").pop() != `${type}.js`) continue;
      let rule = rules(file).default;

      for(let check in rule) {
        if(!rule[check].fn(input, opts)) {
          error = (typeof rule[check].message == 'function') ? rule[check].message(opts) : rule[check].message;
          break;
        }
      }
    }

    return (error) ? {[type]: error} : false;
  }
}

